<template lang="pug">
  el-card.box-card
    .clearfix(slot="header") {{single.region}}/{{single.productName}}
      el-button(style="float:right;padding:0px 0" class="el-icon-delete" @click="removeMe")
    el-row.datasheet(:gutter="10")
      .datasheetInfo
        el-form(label-width="80px" ref="datasheetForm" :rules="rules" :model="single" :size="GLOBAL.SIZE_OF_INPUTBOX")
          el-form-item(label="产品" prop="productName")
            el-input(v-model="single.productName")
          el-form-item(label="地区" prop="region")
            el-input(v-model="single.region" )
          //- el-form-item(label="行业" prop="industryId")
          //-   FrostIndustry(v-model="single.industryId" v-bind:name="single.industry")
          el-form-item(label="预测" prop="prediction")
            el-select(v-model="single.prediction")
              el-option(v-for="item in Prediction" :key="item.value" :label="item.label" :value="item.value")
          el-form-item(label="计量单位" prop="unitName")
            el-select(v-model="single.unitName" filterable allow-create)
              el-option(v-for="item in UnitName" :key="item.value" :label="item.label" :value="item.value")
          el-form-item(label="数量级" prop="unit")
            el-select(v-model="single.unit" filterable)
              el-option(v-for="item in Unit" :key="item.value" :label="item.label" :value="item.value")
          el-form-item(label="权威" prop="authority" allow-create)
            el-select(placeholder="请选择" v-model="single.authority" clearable filterable)
              el-option(v-for="item in Authority" :key="item.value" :label="item.label" :value="item.value")
          el-form-item(label="Y轴方向" prop="yAxis")
            el-radio-group(v-model="single.yAxis")
              el-radio(:label="0") 左
              el-radio(:label="1") 右
          el-form-item(label="种类" prop="kind")
            el-radio-group(v-model="single.kind")
              el-radio(:label="0") pie
              el-radio(:label="1") bar
              el-radio(:label="2") line
      .datasheetCells
        el-row(:gutter="10" v-for="(cell, index) in single.series" :key="index")
          DataCell(:key="cell.id" :cellData="cell" :index="index" @predictive="handelPredictive" :XunitName="XunitName")
        el-row(:gutter="10")
          el-col
            //- el-button(type="success" @click="addCell" :size="GLOBAL.SIZE_OF_INPUTBOX") 增加单元格
            el-button(type="success" @click="addCells" :size="GLOBAL.SIZE_OF_INPUTBOX") Excel粘贴
</template>

<script>
import FrostIndustry from '@/components/industry'
import Enum from '../../../apis/enum'
import DataCell from './DataCell'
export default {
  mounted () {
    // console.log(this.xData)
    // console.log('this.single.series', this.single.series)
    // if (this.single.series.length > 0) {
    //   this.single.series = this.single.series.slice(0, this.xData.length - 1)
    //   for (let i = 0; i < this.xData.length; i++) {
    //     this.single.series[i] = { year: '' }
    //     this.single.series[i].year = this.xData[i]
    //     this.single.series[i].size = ''
    //   }
    // } else {
    //   let temp = []
    //   for (let i = 0; i < this.xData.length; i++) {
    //     temp[i] = { year: '' }
    //     temp[i].year = this.xData[i]
    //   }
    //   this.single.series = temp
    // }
    const temp = []
    for (let i = 0; i < this.xData.length; i++) {
      temp[i] = { year: '' }
      temp[i].year = this.xData[i]
      temp[i].predictive = (this.single.series[i] && this.single.series[i].predictive) || false
      temp[i].size = this.single.series[i] && this.single.series[i].size
    }
    this.single.series = temp
  },
  components: {
    FrostIndustry,
    DataCell
  },
  props: ['single', 'index', 'xData', 'XunitName'],
  name: 'DataSheet',
  data () {
    // var checkIndustry = (rule, value, callback) => {
    //   if (this.single.industryId.length === 0) {
    //     return callback(new Error('至少选择一个行业'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      Prediction: Enum.PREDICTION,
      Authority: Enum.AUTHORITY,
      Unit: Enum.UNITS,
      UnitName: Enum.UNIT_NAME,
      rules: {
        productName: [
          {
            required: true,
            message: '请输入数据表针对描述的产品名称',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    // addCell() {
    //   if (!this.single.series) this.single.series = [];
    //   if (this.single.series.length === 0) {
    //     this.single.series.push({ year: 2013, size: 0, predictive: 0 });
    //   } else {
    //     let max = 0;
    //     this.single.series.forEach(r => {
    //       max = r.year > max ? r.year : max;
    //     });

    //     this.single.series.push({
    //       //增加显示的内容
    //       year: parseInt(max) + 1,
    //       size: "", // this.single.series[this.single.details.length - 1].size,
    //       predictive: this.single.series[this.single.series.length - 1]
    //         .predictive
    //     });
    //   }
    //   this.$forceUpdate();
    // },

    // 上面为我的注释
    async addCells () {
      // eslint-disable-next-line no-useless-escape
      const patten = /[\-*\d+\.*\d*]+/g
      try {
        let year
        let predictive = false
        const r = await this.$prompt(
          '请复制单列或者单行的数据，粘贴到下面到文本框中',
          'Excel粘贴',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: patten,
            inputErrorMessage: '数据格式不正确'
          }
        )
        // let sizes = r.value.match(patten)
        const sizes = r.value.replace(/[,，]/g, '').match(patten)
        if (sizes.length === 0) return
        if (this.single.series.length === 0) {
          const r = await this.$prompt('请起始年份', 'Excel粘贴', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /\d{4}/,
            inputErrorMessage: '年份格式不正确'
          })
          year = r.value
        } else {
          let max = 0
          this.single.series.forEach(r => {
            max = r.year > max ? r.year : max
            predictive = r.predictive || predictive
          })
          year = parseInt(max) + 1
        }
        console.log('year: ', year)
        // 装配
        // for (let size of sizes) {
        //   this.single.series.push({ year, size, predictive })
        //   year++
        // }
        for (let i = 0; i < sizes.length && i < this.single.series.length; i++) {
          this.$set(this.single.series[i], 'size', sizes[i])
        }
      } catch (er) {
        console.log(er)
      }
    },
    handelPredictive (p, index) {
      if (p === 1) {
        for (let i = index + 1; i < this.single.series.length; i++) {
          this.single.series[i].predictive = p
        }
      } else {
        for (let i = index - 1; i >= 0; i--) {
          this.single.series[i].predictive = p
        }
      }
      this.$forceUpdate()
    },
    removeCell (index) {
      this.single.series.splice(index, 1)
    },
    removeMe () {
      this.$emit('remove', this.index)
    },
    verifyForm () {
      return new Promise((resolve, reject) => {
        this.$refs.datasheetForm.validate(valid => {
          if (valid) {
            resolve()
          } else {
            this.$notify({
              title: '错误',
              message: '请完善数据输入',
              type: 'error'
            })
          }
        })
        // if (this.single.industryId.length === 0) {
        // let productName = this.single.productName ? this.single.productName : ''
        // this.$notify({
        //   title: '错误',
        //   message: `产品${productName}至少选择一个行业`,
        //   type: 'error'
        // })
        // } else {
        // this.$refs.datasheetForm.validate((valid) => {
        //   if (valid) {
        //     resolve()
        //   } else {
        //     this.$notify({
        //       title: '错误',
        //       message: '请完善数据输入',
        //       type: 'error'
        //     })
        //   }
        // })
        // }
      })
    }
  }
}
</script>

<style scoped lang="scss">
// Medium devices (tablets, 768px and up)
@media (max-width: 1200px) {
  .el-card {
    width: 100%;
  }
}

// Large devices (desktops, 992px and up)
@media (min-width: 1200.1px) {
  .el-card {
    width: calc(50% - 12px);
  }
}

.datasheet {
  display: flex;
  flex-flow: row nowrap;
  .datasheetInfo {
    padding-right: 5px;
    width: calc(100% - 300px);
    .el-form {
      .el-form-item {
        margin-bottom: 15px;
      }
    }
  }
  .datasheetCells {
    border-left: solid #ccc 1px;
    padding-left: 5px;
    width: 300px;
  }
}
.el-card {
  margin: 0 10px 10px 0;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>
